"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseJobService = void 0;
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const typeorm_1 = require("typeorm/browser");
const invoicing_target_1 = require("./invoicing-target");
const column_numeric_transformer_1 = require("../transformers/column-numeric-transformer");
class BaseJobService {
}
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        name: 'quantity__c',
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseJobService.prototype, "quantity", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'value_entry__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseJobService.prototype, "valueEntry", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'single_selling_price__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseJobService.prototype, "priceSelling", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'single_purchase_price__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseJobService.prototype, "pricePurchasing", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'price_lists__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseJobService.prototype, "priceLists", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'price_selling_sum__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseJobService.prototype, "priceSellingSum", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'price_purchasing_sum__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseJobService.prototype, "pricePurchasingSum", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'price_lists_sum__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseJobService.prototype, "priceListsSum", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'is_active__c',
    }),
    __metadata("design:type", Boolean)
], BaseJobService.prototype, "isActive", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        name: 'product_id__c',
        nullable: true,
    }),
    __metadata("design:type", Boolean)
], BaseJobService.prototype, "productId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        nullable: true,
        type: 'enum',
        name: 'invoicing_target__c',
        enum: invoicing_target_1.InvoicingTargetEnum,
    }),
    __metadata("design:type", String)
], BaseJobService.prototype, "invoicingTarget", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        nullable: true,
        name: 'brand_project_id__c',
        length: 255,
    }),
    __metadata("design:type", String)
], BaseJobService.prototype, "brandProjectId", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        name: 'map_purchasing_negative__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseJobService.prototype, "mapPurchasingNegative", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        name: 'map_selling_negative__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseJobService.prototype, "mapSellingNegative", void 0);
exports.BaseJobService = BaseJobService;
//# sourceMappingURL=base-job-service.js.map